<template>
  <div
    class="kanban-column"
    :style="{ '--kanban-column-color': color, '--kanban-column-opacity': opacity }"
  >
    <div></div>
    <div class="kanban-column__header">
      <div class="kanban-column__indicators-wrap">
        <slot name="indicator"></slot>
        <div class="kanban-column__count-card"><slot name="count"></slot></div>
      </div>
      <div class="kanban-column__tools-wrap">
        <slot name="tools"></slot>
      </div>
    </div>
    <div class="kanban-column__list-card-area">
      <slot name="cards"></slot>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, onMounted, PropType } from "vue";
import { GroupedTaskItemModel, TasksKanbanGroupingModel } from "../../models";

const props = defineProps({
  /**Группировка */
  grouping: {
    type: Object as PropType<TasksKanbanGroupingModel | GroupedTaskItemModel>,
    required: true,
  },
});

const color = computed(() => {
  if (props.grouping.Status) return props.grouping.Status.Color;
  if (props.grouping.Priority)
    return props.grouping.Priority.Color ?? "var(--bg-secondary, #F8F6F9)";
  if (props.grouping.Tag) return props.grouping.Tag.Color;
  return "var(--bg-secondary, #F8F6F9)";
});

const opacity = computed(() => {
  return props.grouping.Status || props.grouping.Priority?.Color || props.grouping.Tag
    ? "0.1"
    : "1";
});
</script>

<style lang="scss" scoped>
.kanban-column {
  position: relative;
  // padding: 0.75rem 0 0.75rem 0.75rem;
  border-radius: 0.5rem;
  min-width: 16.75rem;
  max-width: 20.625rem;
  width: 100%;
  min-height: 3.5rem;
  display: flex;
  flex-direction: column;
  z-index: 2;

  &::before {
    content: "";
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    border-radius: 0.5rem;
    background-color: var(--kanban-column-color);
    opacity: var(--kanban-column-opacity);
    z-index: -1;
  }

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 1rem;
    padding: 0.75rem 0.75rem 0 0.75rem;
  }

  &__indicators-wrap {
    display: flex;
    align-items: center;
    gap: 0.625rem;
  }

  &__count-card {
    font-size: 1rem;
    line-height: 1.5rem;
    color: var(--text-secondary);
  }

  &__list-card-area {
    display: flex;
    flex: 1;
  }
}
</style>
